import Swiper, {Navigation, Pagination, Autoplay} from 'swiper'
import Network from '../../../client/network'
import Ui from '../../../client/client-ui'

export default class Index
{
	static search(prefecture, term)
	{
		try
		{
			location.href = `/find/search/${prefecture}/${term}`
			return false
		}
		catch(exception)
		{
			return false
		}
	}

	static init()
	{
		if(location.hash === '#login') App._common.menu_toggle()
		Swiper.use([Navigation, Pagination, Autoplay])

		if(Ui.is_mobile())
		{
			new Swiper('#_banner', {
				slidesPerView: 1,
				autoplay     : {
					disableOnInteraction: false,
					delay               : 5000,
				},
				autoHeight   : true,
				loop         : true,
				pagination   : {
					el  : '.swiper-pagination',
					type: 'bullets',
				},
				navigation   : {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
			})

			new Swiper('#_coupon', {
				slidesPerView: 1,
				autoHeight   : true,
				loop         : true,
				pagination   : {
					el  : '.swiper-pagination',
					type: 'bullets',
				},
				navigation   : {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
			})

			new Swiper('#_shop', {
				slidesPerView: 1,
				autoHeight   : true,
				loop         : true,
				pagination   : {
					el  : '.swiper-pagination',
					type: 'bullets',
				},
				navigation   : {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
			})
		}
	}

	static banner(type, link, external = false)
	{
		const data = new FormData()

		data.append('_action', 'statistic')
		data.append('type', `banner-${type}`)

		const open = () =>
		{
			if(external) window.open(link)
			else location.href = link
		}

		Network.post(location.pathname, data, open, false)
	}

	static movie(player, mute)
	{
		if(player.muted)
		{
			player.muted = false
			$(mute).addClass('invisible')

			const data = new FormData()

			data.append('_action', 'statistic')
			data.append('type', 'movie')

			Network.post(location.pathname, data, null, false)
		}
		else
		{
			player.paused ? player.play() : player.pause()
		}
	}

	static scroll(selector)
	{
		$('html,body').animate({scrollTop: $(selector).offset().top}, 'slow')
	}
}
